export enum StorageProviderFileType {
  Lazy = 'lazy',
}

export enum SyncPreferenceValues {
  ApprovalPublish = 'approval',
  AutoPublish = 'auto',
  NotSync = 'no_sync',
}

export enum SyncStatusValues {
  AccountDisconnected = 'account_disconnected',
  Approved = 'approved',
  AutoSynced = 'auto_synced',
  FileNotFound = 'file_not_found',
  NotSynced = 'no_synced',
  PendingReview = 'pending_review',
}

export enum SyncPreferenceGroups {
  Sync = 'Sync with Google Drive',
  DontSync = `Don't sync with Google Drive`,
}

export enum SyncPreferenceLabels {
  AutoPublish = 'Automatically publish updates',
  DontSync = 'Do not sync updates',
  ManuallyPublish = 'Manually publish updates',
}

export enum StorageProviderAuthTypes {
  Organization = 'organization',
  Personal = 'personal',
  Shared = 'shared',
}

export enum StorageProviderAuthOwnerType {
  Organization = 'Organization',
  User = 'User',
}

export enum StorageProviderAuthShareType {
  Organization = 'Organization',
  Team = 'Team',
  User = 'User',
}
